import { render, staticRenderFns } from "./BadgeHolderView.vue?vue&type=template&id=030b30c0"
import script from "./BadgeHolderView.vue?vue&type=script&lang=js"
export * from "./BadgeHolderView.vue?vue&type=script&lang=js"
import style0 from "./BadgeHolderView.vue?vue&type=style&index=0&id=030b30c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports